import React from 'react';
import styles from './JuryBadge.module.scss';

/**
 * Yellow pill badge for jury UI counts (bookmarks, votes, remaining points).
 */
const JuryBadge = ({ children }) => (
    <span className={styles.JuryBadge}>
        <span className="visually-hidden">Aktuelle Anzahl: </span>
        {children}
    </span>
);

export default JuryBadge;
